module.exports = __webpack_public_path__ + "img/zigbee.976d8f6c.svg";